const LOCALES = [
  { locale: 'es', match: /es/ },
  { locale: 'en', match: /en/ },
  { locale: 'de', match: /de/ },
  { locale: 'fr', match: /fr/ },
  { locale: 'it', match: /it/ },
  { locale: 'pt', match: /pt/ },
  { locale: 'ca', match: /ca/ },
]

export default LOCALES
